import React from 'react';
import './notification.scss';
import NotificationItem from './NotificationItem/notificationItem';

export default function Notifications(props) {
  const { notificationsList, onClearAllNotification } = props;
  if (notificationsList) {
    console.log(notificationsList, 'notificationsList');
  }
  return (
    <div className="notificationListContainer">
      <div className="notificationListTitle">{notificationsList.length} اعلان خوانده نشده</div>
      <div className="notificationActionCenter">
        <a onClick={onClearAllNotification} className="notificationActionCenterClearAll">
          حذف تمام اعلانیه ها
        </a>
      </div>
      {notificationsList &&
        notificationsList.map(notification => (
          <NotificationItem notification={notification} key={notification.id} />
        ))}
    </div>
  );
}
